import React from 'react';
import '../main.css'

function Footer(props){

    let currentPage = window.location.pathname;
    let disclaimerLink = 'https://www.anz.co.nz/OA-legalinfo';
    if (currentPage === "/ANZUnitPrices" || currentPage === "/ANZHistoricalUnitPrices")
         disclaimerLink = 'https://www.anz.co.nz/fundinformation';


    return (
      <div className="footer">
        <div style={{marginBottom: 0}}>
          <div class="container">
              <div class="panel-body" style={{paddingLeft:"0px"}} >
                <div class="row">
                  <div class="col-md-12">
                    <div class="col-md-2 footer-link" style={{paddingLeft: "0px"}}>
                      <a href="https://www.anz.co.nz/comms/website-terms-of-use/" rel="noopener noreferrer" target="_blank">Website Terms of Use</a>
                    </div>
                    <div class="col-md-2 footer-link" style={{paddingLeft: "0px"}}>
                      <a href="https://www.anz.co.nz/about-us/media-centre/investor-information/" rel="noopener noreferrer" target="_blank"> Disclosure Statement</a>
                    </div>
                    <div class="col-md-4 footer-link" style={{paddingLeft: "0px"}}>
                      <a href={disclaimerLink} rel="noopener noreferrer" target="_blank">Legal Information and Disclaimers</a>
                    </div>
                  </div>
                </div>
                <div class="row footerRow">
                  <div class="col-md-12">
                      <p className="footer-text">© ANZ New Zealand Investments Limited, a subsidiary of ANZ Bank New Zealand Limited.</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
        </div>
  )
}

export default Footer;
